"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportSortTypeToJSON = exports.ReportSortTypeFromJSONTyped = exports.ReportSortTypeFromJSON = exports.ReportSortType = void 0;
/**
 * The entity metadata by which to sort. NAME and STATUS are available for all entity types.
 * AD_SET_BUDGET, AD_SET_START_TIME, and AD_SET_END_TIME are only available for the ad set
 * dimension. This field is required if sort_direction is set.
 *
 * @export
 */
exports.ReportSortType = {
    AdSetBudget: 'AD_SET_BUDGET',
    AdSetEndTime: 'AD_SET_END_TIME',
    AdSetStartTime: 'AD_SET_START_TIME',
    Name: 'NAME',
    Status: 'STATUS'
};
function ReportSortTypeFromJSON(json) {
    return ReportSortTypeFromJSONTyped(json, false);
}
exports.ReportSortTypeFromJSON = ReportSortTypeFromJSON;
function ReportSortTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ReportSortTypeFromJSONTyped = ReportSortTypeFromJSONTyped;
function ReportSortTypeToJSON(value) {
    return value;
}
exports.ReportSortTypeToJSON = ReportSortTypeToJSON;
